<template>
  <div class="dashboard">
    <loading ref="wLoadScreen" />
    <header-navigation :enableNoBorder="true"/>
    <div class="container" style="justify-content: center; align-items: center;">
      <oops ref="wOops" />
      <error ref="wError" />
      <weather-forecast ref="wForecast" style="width: 100vw;" :style="{height: showDownload ? '80vh' : '100vh'}"/>
      <button @click="downloadCSV" class="singleRowFlex downloadLink" style="cursor: pointer;" v-if="weatherData && showDownload">
        <img class="icon" :src="require('@/assets/icons/download.svg')" alt="download" />
        <p class="link">Download Weather Data</p>
      </button>
    </div>
    <bottom-credits style="margin-top: 0;" :enableNoBorder="true"/>
  </div>
</template>

<script>
import axios from 'axios';
import WeatherForecast from "../components/weather/WeatherForecast.vue";
import Loading from "../components/Loading.vue";
import BottomCredits from "../components/BottomCredits.vue";
import HeaderNavigation from "../components/HeaderNavigation.vue";
import Oops from "../components/Oops.vue";
import Error from "../components/Error.vue";

export default {
  name: "Weather",
  components: {
    WeatherForecast,
    Loading,
    BottomCredits,
    HeaderNavigation,
    Oops,
    Error
  },
  data: () => ({
    weatherData: null,
    showDownload: true,
    showLoading: true
  }),
  mounted() {
    var globv = this;
    globv.checkLoading();
    globv.startUp();
    globv.checkNoBorder();
  },
  methods: {
    startUp: function() {
        var globv = this;
        if (globv.showLoading)
          globv.$refs.wLoadScreen.startLoading();
        if (globv.$route.params.mmsi) {
          let mmsi = globv.$route.params.mmsi;

          if (window.sessionStorage.getItem("weather" + mmsi)) {
            let weatherStorage = JSON.parse(
                window.sessionStorage.getItem("weather" + mmsi)
            );
            if (Date.now() - weatherStorage["created"] < 3600000) {
                globv.weatherData = weatherStorage["weatherData"];
                globv.$refs.wForecast.createChart(weatherStorage["weatherData"]);
                if (globv.showLoading)
                  setTimeout(globv.$refs.wLoadScreen.finishLoading, 100);
                return;
            }
          }

          globv.retrieveDataMMSI(mmsi);
        }
        else if (globv.$route.query.lat && globv.$route.query.lon) {
          let lat = globv.$route.query.lat;
          let lon = globv.$route.query.lon;

          if (window.sessionStorage.getItem(`weather(${lon},${lat})`)) {
            let weatherStorage = JSON.parse(
                window.sessionStorage.getItem(`weather(${lon},${lat})`)
            );
            if (Date.now() - weatherStorage["created"] < 3600000) {
                globv.weatherData = weatherStorage["weatherData"];
                globv.$refs.wForecast.createChart(weatherStorage["weatherData"]);
                if (globv.showLoading)
                  setTimeout(globv.$refs.wLoadScreen.finishLoading, 100);
                return;
            }
          }

          globv.retrieveDataLatLon(lat, lon);
        }
        else {
          globv.$refs.wError.showError({
            status: 400,
            title: "Bad Request",
            message: "Please enter a valid latitude and longitude query request"
          });
          if (globv.showLoading)
            setTimeout(globv.$refs.wLoadScreen.finishLoading, 10);
        }
    },
    retrieveDataMMSI: async function(mmsi) {
      var globv = this;
      try {
        let response = await axios.get('/api/weather/' + mmsi);

        if (response["data"]) {
          globv.weatherData = response["data"];
          globv.$refs.wForecast.createChart(response["data"]);
          try {
            window.sessionStorage.setItem(
              "weather" + mmsi,
              JSON.stringify({
                weatherData: response["data"],
                created: Date.now()
              })
            );
          } catch(e) { console.log(e); }
          
          if (globv.showLoading)
            setTimeout(globv.$refs.wLoadScreen.finishLoading, 100);
        }
      } catch (error) {
        globv.handleError(error);
      }
    },
    retrieveDataLatLon: async function(lat, lon) {
      var globv = this;
      try {
        let response = await axios.get('/api/weather', {
          params: {
            lat: lat,
            lon: lon
          }
        });

        if (response["data"]) {
          globv.weatherData = response["data"];
          globv.$refs.wForecast.createChart(response["data"]);
          try {
            window.sessionStorage.setItem(
              `weather(${lon},${lat})`,
              JSON.stringify({
                weatherData: response["data"],
                created: Date.now()
              })
            );
          } catch(e) { console.log(e); }
          
          if (globv.showLoading)
            setTimeout(globv.$refs.wLoadScreen.finishLoading, 100);
        }
      } catch (error) {
        globv.handleError(error);
      }
    },
    handleError: function(error) {
      var globv = this;
      console.log(error, error.response);
      if (error && error.response && error.response.data)
        error = error.response.data;
      if (error["error"] && error["error"]["status"] < 500) {
        if (error["error"]["status"] == 404)
          globv.$refs.wError.showError({
            status: 404,
            title: "Not Found",
            message: error["error"]["message"]
          });
        else
          globv.$refs.wError.showError({
            status: error["error"]["status"],
            message: error["error"]["message"]
          });
      } else globv.$refs.wOops.showOops();
      if (globv.showLoading)
        setTimeout(globv.$refs.wLoadScreen.finishLoading, 100);
    },
    downloadCSV: function() {
      var globv = this;

      let formatData = [
        {
          varName: "airTemp",
          labelName: "Air Temp",
          unit: "°C"
        },
        {
          varName: "seaTemp",
          labelName: "Sea Temp",
          unit: "°C"
        },
        {
          varName: "dewTemp",
          labelName: "Dew Temp",
          unit: "°C"
        },
        {
          varName: "waveHeight",
          labelName: "Wave Height",
          unit: "m"
        },
        {
          varName: "baromPressure",
          labelName: "Barometric Pressure",
          unit: "kPa"
        },
        {
          varName: "windSpeed",
          labelName: "Wind Speed",
          unit: "m/s"
        },
        {
          varName: "windDir",
          labelName: "Wind Direction",
          unit: "deg"
        },
        {
          varName: "currentSpeed",
          labelName: "Ocean Current Speed",
          unit: "m/s"
        },
        {
          varName: "currentDir",
          labelName: "Ocean Current Direction",
          unit: "deg"
        }
      ];

      let date = [];
      let values = {};

      let filledLabel = false;
      for (let format in formatData) {
        let tempData = [];
        let dataValues = globv.weatherData[formatData[format]["varName"]];
        for (let d in dataValues) {
          if (!filledLabel) {
            date.push((new Date(dataValues[d]["validTime"])).toLocaleString().replace(',', ''));
          }

          tempData.push(dataValues[d]["value"]);
        }
        filledLabel = true;

        values[formatData[format]["varName"]] = tempData;
      }

      let csvData = "Valid Time";

      // add variable names
      for (let format in formatData) {
        csvData +=
          "," +
          formatData[format]["labelName"] +
          " (" +
          formatData[format]["unit"] +
          ")";
      }
      csvData += "\n";

      for (let d in date) {
        csvData += date[d];
        for (let v in values) {
          csvData += "," + values[v][d];
        }
        csvData += "\n";
      }

      let name = globv.$route.params.mmsi + "_weather.csv";

      let blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      let url = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    checkNoBorder: function() {
      var globv = this;
      if (![null, undefined].includes(globv.$route.query.noborder)) {
          let bool = globv.$route.query.noborder.toLowerCase() == 'true' ? true : false;
          globv.showDownload = !bool;
      }
      else {
          globv.showDownload = true;
      }
      setTimeout(globv.$refs.wForecast.reflow, 0);
    },
    checkLoading: function() {
      var globv = this;
      if (![null, undefined].includes(globv.$route.query.loading)) {
          let bool = globv.$route.query.loading.toLowerCase() == 'false' ? false : true;
          globv.showLoading = bool;
      }
      else {
          globv.showLoading = true;
      }
    }
  },
  watch: {
    '$route.params.mmsi': function() {
      var globv = this;
      globv.startUp();
    },
    '$route.query.noborder': function() {
      var globv = this;
      globv.checkNoBorder();
    },
    '$route.query.loading': function() {
      var globv = this;
      globv.checkLoading();
    }
  }
};
</script>